// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6706) return "static/chunks/6706-3f7c838de86b043c.js";
	if (chunkId === 6837) return "static/chunks/6837-00202a1a07cced06.js";
	if (chunkId === 8718) return "static/chunks/8718-5d74fc65c6871d9c.js";
	if (chunkId === 5560) return "static/chunks/5560-611a3c1a623e44f0.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"1831":"bd904a5c","3682":"b79b7286","9367":"b536a0f1"}[chunkId] || chunkId) + "." + {"326":"77bb491fefe9806f","1402":"450e79e36c3cbc7a","1831":"788cdbbaa8dc43f9","2741":"1be279e60af8aa8c","3682":"267c0a6128fcf4f8","6143":"ebf670ab20d25ac8","6287":"ed5a429fe21e8a77","9098":"d6da9e11040db203","9194":"b0b39848b78a8442","9367":"ca9f1328c3e65f72"}[chunkId] + ".js";
};